import {ButtonGroup, closeCurrentDialog, showNotification} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import {useState} from 'react';
import {useDispatch} from 'react-redux';

import {head, isNil} from 'ramda';

import {metadaRentalOrderApi, useChangeRentalOrderServiceOrderMutation} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {DmsDataGrid, handleApiError} from '@dms/shared';

interface PairWithServiceOrderFormProps {
  rentalOrderId: string;
}

export function PairWithServiceOrderForm(props: PairWithServiceOrderFormProps) {
  const [pairWithRentalOrder, {isLoading}] = useChangeRentalOrderServiceOrderMutation();

  const dispatch = useDispatch();

  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

  const handlePairWithServiceOrder = () => {
    if (isNil(selectedRowId)) {
      showNotification.error();
      return;
    }

    pairWithRentalOrder({
      rentalOrderId: props.rentalOrderId,
      changeRentalOrderServiceOrderRequestBody: {
        serviceOrderId: selectedRowId,
      },
    })
      .unwrap()
      .then(() =>
        dispatch(
          metadaRentalOrderApi.util.invalidateTags([
            {type: 'serviceRentalOrder', id: props.rentalOrderId},
          ])
        )
      )
      .then(closeCurrentDialog)
      .catch(handleApiError);
  };

  return (
    <VStack spacing={4}>
      <Box height={150}>
        <DmsDataGrid
          gridCode="assign-rental-order-to-service-order"
          onRowSelectionChange={(row) => {
            const firstRow = head(row)?.id ?? null;
            setSelectedRowId(firstRow);
          }}
        />
      </Box>

      <ButtonGroup
        align="right"
        buttons={[
          {
            title: i18n.t('general.actions.close'),
            onClick: closeCurrentDialog,
            variant: 'secondary',
          },
          {
            title: i18n.t('general.actions.save'),
            onClick: handlePairWithServiceOrder,
            isDisabled: isNil(selectedRowId),
            isLoading,
          },
        ]}
      />
    </VStack>
  );
}
